<template>
    <el-container class="Wrapper">
        <el-container class="container">
            <div class="shangs">
                <div class="comms">
                    <div class="fenss">
                        <el-form :model="searchForm">
                            <el-input v-model="searchForm.name" placeholder="请输入菜品名称" @keyup.enter="siftsea"></el-input>
                            <el-button type="primary" @click="siftsea">查找</el-button>
                            <el-button type="primary" @click="openAddDialog">添加菜单</el-button>
                        </el-form>
                    </div>
                    <div class="dishesbody">
                        <el-table v-loading="loading" element-loading-text="加载中，请稍后..."
                            style="width: 100%; margin-left: 10%;" height="85%" :data="management" class="orders">
                            <el-table-column label="序号" width="70">
                                <template v-slot="{ $index }">
                                    {{ $index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="dishName" label="名称" width="100" show-overflow-tooltip />
                            <el-table-column prop="dishCategory" label="类别" width="70">
                            </el-table-column>
                            <el-table-column label="修改" width="250">
                                <template #default="scope">
                                    <el-button type="danger" @click="open(scope.row.id)">删除菜单</el-button>
                                    <el-button type="primary" @click="openEditDialog(scope.row.id)">编辑菜单</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="dishesfoots">
                        <div class="demo-pagination-blocks">
                            <el-pagination v-model:current-page="currentPage4" v-model:page-size="pageSize4"
                                @size-change="handleSizeChangese" @current-change="handleCurrentChangese"
                                :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper" :total="tatol">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <!-- 添加/编辑商品弹窗 -->
                <el-dialog v-model="addDialogVisible" title="添加/编辑菜单" :width="dialogWidth" :top="dialogTop">
                    <el-form v-model="newDish">
                        <el-form-item label="菜单日期">
                            <el-select v-model="newDish.week" placeholder="请选择日期">
                                <el-option
                                    v-for="day in weekDays"
                                    :key="day"
                                    :label="day"
                                    :value="day">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="菜品类别">
                            <el-select v-model="newDish.categoriesId" placeholder="请选择类别">
                                <el-option
                                    v-for="category in categories"
                                    :key="category.id"
                                    :label="category.name"
                                    :value="category.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="菜谱菜品">
                            <el-table :data="newDish.detailList" stripe @row-click="handleRowClick"
                                :row-style="rowStyle">
                                <el-table-column label="菜品名称" prop="foodIngredients">
                                    <template #default="scope">
                                        <el-input v-model="scope.row.foodIngredients" readonly @click="openChooseDishDialog(scope.$index)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="菜品类别" prop="dishCategory">
                                    <template #default="scope">
                                        <el-input v-model="scope.row.dishCategory"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-form>
                    <!-- <div class="btn-container">
                        </div> -->
                    <template #footer>
                        <el-button type="primary" @click="addIngredient">增加行</el-button>
                        <el-button type="danger" @click="removeSelectedIngredient"
                            :disabled="selectedRowIndex === -1">删除选中行</el-button>

                        <el-button @click="addDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="saveDish">确定</el-button>
                    </template>
                </el-dialog>
                <!-- 选择菜品弹窗 -->
                <ChooseDoctors :modelValue="chooseDishDialogVisible" @confirm="confirmChooseDish" @update:modelValue="updateChooseDishVisible"></ChooseDoctors>
            </div>
        </el-container>
    </el-container>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { toRaw } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import instance from '../network/storester.js';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ElIconPlus, ElIconMinus } from '@element-plus/icons-vue';
import ChooseDoctors from '../menumanagement/ChooseDish.vue'; // 引入选择菜品组件

const searchForm = ref({
    name: '',
});

const tatol = ref(0);
const management = ref([]);
const managem = ref(null);
const loading = ref(true);
const router = useRouter();
const manage = localStorage.getItem('permissionsStatus');
const page = reactive({ pageNum: 1, pageSize: 10 });

// 新增/编辑商品弹窗相关
const addDialogVisible = ref(false);
const newDish = ref({
    detailList: [
        {
            dishId: 0,
            foodIngredients: '',
            grammage: 0,
            id: 0,
            isDeleted: 0,
            portion: '',
            powerFactor: 0
        }
    ],
    dishCategory: '',
    dishName: '',
    id: 0,
    isDeleted: 0,
    week: '',
    categoriesId: ''
});
const selectedRowIndex = ref(-1);
const dialogWidth = ref('60%'); // 自定义弹窗宽度
const dialogTop = ref('10vh'); // 自定义弹窗顶部距离
const isEdit = ref(false); // 判断是添加还是编辑

// 选择菜品弹窗相关
const chooseDishDialogVisible = ref(false);
const currentEditIndex = ref(-1);

// 日期选项
const weekDays = ref(['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']);
// 分类数据
const categories = ref([]);

const handleSizeChangese = (val) => {
    page.pageSize = val;
    //console.log(val);
    loading.value = true;
    siftsea();
};

// 当前页改变时触发
const handleCurrentChangese = (val) => {
    page.pageNum = val;
    //console.log(val);
    loading.value = true;
    siftsea();
};

const siftsea = () => {
    instance.get(`/api/dish/list?dishName=${searchForm.value.name}&pageNum=${page.pageNum}&pageSize=${page.pageSize}`)
        .then(response => {
            managem.value = response.data.data.dataList;
            management.value = toRaw(managem.value);
            tatol.value = response.data.data.total;
            //console.log(management.value);
            loading.value = false;
        })
        .catch(error => {
            //console.log(error);
            ElMessage({
                showClose: true,
                message: '请登录',
                type: 'error',
            });
            router.push('./');
        });
};

// 获取分类数据
const getCategories = () => {
    instance.get('/api/categories/getMeanCategories')
      .then(response => {
            categories.value = response.data.data;
        })
      .catch(error => {
            //console.log(error);
            ElMessage({
                type: 'error',
                message: '获取分类数据失败，请稍后重试',
            });
        });
};

const open = (id) => {
    ElMessageBox.confirm(
        '您确定要删除该商品吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            instance.get(`/api/dish/deleted/${id}`)
                .then(response => {
                    loading.value = true;
                    ElMessage({
                        type: 'success',
                        message: '删除成功',
                    });
                    siftsea();
                })
                .catch((error) => {
                    //console.log(error);
                });
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: '取消删除',
            });
        });
};

const openAddDialog = () => {
    addDialogVisible.value = true;
    selectedRowIndex.value = -1;
    isEdit.value = false;
    newDish.value = {
        detailList: [
            {
                dishId: 0,
                foodIngredients: '',
                grammage: 0,
                id: 0,
                isDeleted: 0,
                portion: '',
                powerFactor: 0
            }
        ],
        dishCategory: '',
        dishName: '',
        id: 0,
        isDeleted: 0,
        week: '',
        categoriesId: ''
    };
};

const openEditDialog = (id) => {
    instance.get(`/api/dish/${id}`)
        .then(response => {
            addDialogVisible.value = true;
            selectedRowIndex.value = -1;
            isEdit.value = true;
            newDish.value = response.data.data;
        })
        .catch(error => {
            ElMessage({
                type: 'error',
                message: '获取菜品信息失败，请稍后重试',
            });
        });
};

const saveDish = () => {
    // 手动校验菜品名称和类别
    if (!newDish.value.dishName.trim()) {
        ElMessage({
            type: 'error',
            message: '菜品名称为必填项'
        });
        return;
    }
    if (!newDish.value.dishCategory.trim()) {
        ElMessage({
            type: 'error',
            message: '菜品类别为必填项'
        });
        return;
    }

    // 检查菜品部分的校验
    for (const row of newDish.value.detailList) {
        const hasValue = row.foodIngredients.trim() || row.grammage || row.portion.trim();
        if (hasValue) {
            if (!row.foodIngredients.trim()) {
                ElMessage({
                    type: 'error',
                    message: '若某一行中有一个字段不为空，则菜品名称必须填写'
                });
                return;
            }
            if (!row.grammage) {
                ElMessage({
                    type: 'error',
                    message: '若某一行中有一个字段不为空，则菜品克数必须填写'
                });
                return;
            }
            if (!row.portion.trim()) {
                ElMessage({
                    type: 'error',
                    message: '若某一行中有一个字段不为空，则菜品分量必须填写'
                });
                return;
            }
        }
    }

    // 确保 detailList 中不为空的项才添加到数组
    const validDetailList = newDish.value.detailList.filter(item => item.foodIngredients.trim() !== '');
    newDish.value.detailList = validDetailList;

    const apiUrl = '/api/dish/save';
    instance.post(apiUrl, newDish.value)
        .then(response => {
            if (response.data.state === 20000) {
                ElMessage({
                    type: 'success',
                    message: `${isEdit.value ? '编辑' : '新增'}菜品成功`,
                });
                addDialogVisible.value = false;
                siftsea(); // 刷新列表
            } else {
                ElMessage({
                    type: 'error',
                    message: response.data.msg || '添加失败',
                });
            }

        })
        .catch(error => {
            //console.log(`${isEdit.value ? '编辑' : '新增'}菜品失败`, error);
            ElMessage({
                type: 'error',
                message: `${isEdit.value ? '编辑' : '新增'}菜品失败，请稍后重试`,
            });
        });
};

const addIngredient = () => {
    const newItem = {
        dishId: 0,
        foodIngredients: '',
        grammage: 0,
        id: 0,
        isDeleted: 0,
        portion: '',
        powerFactor: 0
    };
    newDish.value.detailList.push(newItem);
};

const removeSelectedIngredient = () => {
    if (selectedRowIndex.value !== -1 && newDish.value.detailList.length > 1) {
        newDish.value.detailList.splice(selectedRowIndex.value, 1);
        selectedRowIndex.value = -1;
    }
};

const handleRowClick = (row, event, column) => {
    const index = newDish.value.detailList.indexOf(row);
    selectedRowIndex.value = index;
};

const rowStyle = ({ row, rowIndex }) => {
    if (rowIndex === selectedRowIndex.value) {
        return { background: '#e5f6ff' };
    }
    return {};
};

const openChooseDishDialog = (index) => {
    chooseDishDialogVisible.value = true;
    currentEditIndex.value = index;
};

const confirmChooseDish = (selectedDish) => {
    if (selectedDish.length > 0) {
        newDish.value.detailList = selectedDish.map((dish) => ({
            dishId: 0,
            foodIngredients: dish.dishName,
            grammage: 0,
            id: 0,
            isDeleted: 0,
            portion: '',
            powerFactor: 0,
            dishCategory: dish.dishCategory // 假设选择的菜品有 dishCategory 属性
        }));
    }
    chooseDishDialogVisible.value = false;
};

const updateChooseDishVisible = (value) => {
    chooseDishDialogVisible.value = value;
};

onMounted(() => {
    siftsea();
    getCategories();
});
</script>
<style>
.leftnavbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 15vw;
    height: 100vh;
    background-color: #545c64;
}

.container {
    position: fixed;
    top: 0;
    left: 15vw;
}

.container_top {
    width: 85vw;
    height: 10vh;
    background-color: #545c64;
}

.main {
    position: fixed;
    top: 10vh;
    left: 11vw;
    width: 85vw;
    height: 90vh;
}

.orders {
    position: fixed;
    margin-top: 15vh;
    left: 8vw;
}

.fenss .el-select {
    width: 14vw;
    font-size: 12px;
    margin-left: 10px;
}

.comms .el-table {
    position: fixed;
    top: 6%;
    left: 1%;
}

.comms.el-table tr.el-table__row {
    height: 65px !important;
    font-size: 12px !important;
}

.shangs {
    font-size: 12px !important;
}

.el-table {
    width: 100%;
}

.el-table__header-wrapper table,
.el-table__body-wrapper table {
    width: 100% !important;
}

.el-table__body,
.el-table__footer,
.el-table__header {
    table-layout: auto;
}

.addproduct {
    position: static;
    margin-left: 10px;
}

.addproducts {
    position: fixed;
    top: 14vh;
    right: 15vw;
}

.fenss {
    position: fixed;
    top: 13vh;
    z-index: 1;
}

.fenss .el-input {
    width: 15vw;
}

.fenss .switchs {
    left: 30vw;
}

.dishesfoots .demo-pagination-blocks {
    position: fixed;
    width: 100vw;
    top: 94vh;
    height: 10vh;
    left: 30vw;
}

/* 新增弹窗样式 */
.el-dialog__body {
    padding: 10px;
    /* 减少弹窗内的上下左右间距 */
}

.el-form-item__label {
    /* 设置表单项名称的固定宽度，使它们长度一致 */
    text-align: right;
    padding-right: 10px;
}

.shangs.el-form-item {
    margin-bottom: 20px !important;
}

.el-form-item {
    display: flex;
    align-items: center;
}

.shangs .el-form-item__label {
    flex: 0 0 80px;
}

.shangs .el-input {
    flex: 1;
    margin-right: 10px;
}

.shangs .btn-container {
    position: absolute;
    bottom: 10px;
    left: 10px;
    display: flex;
    gap: 10px;
}

</style>    